import React from 'react';
import { Space } from '@drip/drip-design';
import './index.less';

interface PropsType {
  title: React.ReactNode;
  descriptionList?: Array<{ key: React.ReactNode; value: React.ReactNode }>;
  rightBtn?: React.ReactNode;
}

function HeaderInfo(props: PropsType) {
  const { title, descriptionList = [], rightBtn = null } = props;
  return (
    <div className="spacial-list-header-info-block">
      <div>
        <div className="header-info-title">{title}</div>
        {descriptionList.length > 0 && (
          <Space className="header-info-description" size="middle">
            {descriptionList.map((item, index) => {
              return (
                <span key={index}>
                  {item.key}：{item.value}
                </span>
              );
            })}
          </Space>
        )}
      </div>
      <div>{rightBtn}</div>
    </div>
  );
}

export default HeaderInfo;
